export const LANGUAGE_CODE_NAMES = {
  ar: 'العربية',
  bg: 'Български',
  cs: 'Česky',
  da: 'Dansk',
  de: 'Deutsch',
  en: 'English',
  'en-gb': 'English (UK)',
  es: 'Español',
  et: 'Eesti keel',
  fi: 'Suomi',
  fr: 'Français',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  lt: 'Lietuvių kalba',
  lv: 'Latviešu valoda',
  nl: 'Nederlands',
  no: 'Norsk',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  ru: 'Pусский',
  sv: 'Svenska',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  'zh-hans': '简体中文',
  'zh-hant': '繁體中文',
} as const;
